import { useState, useEffect, useMemo } from "react";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import CustomInput from "../../../components/common/CustomInput/CustomInput";
import CustomDateTimePicker from "../../../components/common/CustomDateTimePicker/CustomDateTimePicker";
import CustomTextArea from "../../../components/common/CustomTextArea/CustomTextArea";
import CustomFileUpload from "../../../components/common/CustomFileUpload/CustomFileUpload";
import { useFormik } from "formik";
import CustomDatePicker from "../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomModal from "../../../components/common/Modal";
import { useSelector, useDispatch } from "react-redux";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import {
   approveTripDetailsAsync,
   rejectTripDetailsAsync,
   singleTripAsync,
   updateTripDetailsAsync,
   updateTripManagerAsync,
   updateTripReviewStatusAsync,
} from "../../../redux/features/tripSlice";
import { useParams, useNavigate } from "react-router-dom";
import { ROLES } from "../../../constansts/Roles";
import toast from "react-hot-toast";
import * as yup from "yup";
import { createActualAsync } from "../../../redux/features/createActualSlice";
import selectOptionData from "../../../constansts/LocalData";
import CustomDropdown from "../../../components/common/CustomDropdown/CustomDropdown";
import {
   fetchAllFleetEditAsync,
   fetchDriverRecordByVendorIdAsync,
   fetchLaneRecordByIdAsync,
} from "../../../redux/features/driverMaster";
import useTrip from "../../../Hooks/useTrip";

const updateManagerSchema = yup.object().shape({
   destination_reported_date: yup
      .string()
      .required("Destination Reported Date Time is required!"),
   destination_unloading_date: yup
      .string()
      .required("Destination Uploading Date Time is required!"),
   // POD_upload: editfileSchema,
   // POD_remarks: yup.string().required("POD remarks is required!"),
});

export default function ContractualTripEdit() {
   const role_id = useSelector((state) => state?.auth?.user?.data?.user?.role_id);
   const { laneForTripApiCall, laneForTrip } = useTrip();

   const trip = useSelector((state) => state.trip);
   const singleTrip = trip?.singleTrip?.[0];
   const [modal, setModal] = useState({
      isOpen: false,
      type: "",
      title: "",
   });
   const [rejectRemarks, setRejectRemarks] = useState("");
   const [isUpdated, setIsUpdated] = useState(false);

   const [diffMs, setDiffMs] = useState(0);
   const [diffDays, setDiffDays] = useState(0);

   const userRoleId = useSelector((state) => state?.auth?.user?.data?.user?.role_id);
   let roleName;
   // Finding the rolename from roles
   for (const key in ROLES) {
      if (ROLES[key] === userRoleId) {
         roleName = key;
      }
   }

   const [modalData, setModalData] = useState({
      date: "",
      fieldValue: "",
      comment: "",
   });
   const [addMoreError, setAddMoreError] = useState(false);

   const dispatch = useDispatch();
   const navigate = useNavigate();
   const params = useParams();

   useEffect(() => {
      laneForTripApiCall();
   }, []);

   // Fetch single trip
   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         singleTripAsync({
            id: params.id,
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, []);

   // Fetch single trip if any field get updated
   useEffect(() => {
      if (isUpdated) {
         dispatch(
            singleTripAsync({
               id: params.id,
               done: () => {},
               err: (error) => {},
            }),
         );
         setIsUpdated(false);
      }
   }, [isUpdated]);

   // Manager update fields
   const handleUpdateManager = (formData) => {
      const request = {
         id: params.id,
         destination_reported_date: formData.destination_reported_date,
         destination_unloading_date: formData.destination_unloading_date,
         POD_upload: formData.POD_upload,
         POD_remarks: formData.POD_remarks,
         model_id: 2,
         action_id: 3,
         trip_status: "closed",
         _method: "PATCH",
      };
      const newData = new FormData();
      Object.entries(request).forEach(([key, value]) => {
         newData.append(key, value);
      });
      // console.log("newData", request);
      // return;

      dispatch(backdropLoadingAction(true));

      dispatch(
         updateTripManagerAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Updated successfully.");
               navigate("/trip/contractual/view");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: {
         customername: "",
         vehicle_no: "",
         drivername: "",
         driverno: "",
         lane: "",
         origin: "",
         destination: "",
         ewaybillno: "",
         ewaybill_expiry_date: "",
         invoice_no: "",
         invoice_date: "",
         invoice_value: "",
         customer_lrno: "",
         vehicle_reported_date: "",
         vehicle_disptch_date: "",
         actual_diesel_provided: "",
         actual_adblue_provided: "",
         actual_driver_trip_advance: "",
         actual_miscellaneous_expense: "",
         actualMiscExpenceRemarks: "",
         destination_reported_date: "",
         destination_unloading_date: "",
         POD_upload: "",

         // POD_remarks: "",
         trip_status: "",
         review_status: "",

         loadingCharges: "",
         unloadingCharge: "",
         miscellaneousCharges: "",
         miscellaneousRemarks: "",
         dieselRate: "",
         adblueRate: "",
         foodAllowance: "",
         parking: "",
         miscellaneousRate: "",
      },
      validationSchema:
         roleName === "manager" || roleName === "management" ? updateManagerSchema : "",
      onSubmit: (values) => {
         if (roleName === "manager" || roleName === "management") {
            handleUpdateManager(values);
         }
      },
   });

   const { setValues, setFieldValue, getFieldProps, errors, touched, values } = formik;

   useEffect(() => {
      if (singleTrip) {
         setValues({
            customername: singleTrip?.customername ?? "",
            vehicle_no: singleTrip?.vehicle_no ?? "",
            drivername: singleTrip?.drivername ?? "",
            driverno: singleTrip?.driverno ?? "",
            //lane: singleTrip?.lane_masters?.name ?? "",
            lane: singleTrip?.lane ?? "",
            origin: singleTrip?.lane_masters?.origin_location_master?.name ?? "",
            destination:
               singleTrip?.lane_masters?.destination_location_master?.name ?? "",
            ewaybillno: singleTrip?.ewaybillno ?? "",
            ewaybill_expiry_date: singleTrip?.ewaybill_expiry_date ?? "",
            invoice_no: singleTrip?.invoice_no ?? "",
            invoice_date: singleTrip?.invoice_date ?? "",
            invoice_value: singleTrip?.invoice_value ?? "",
            customer_lrno: singleTrip?.customer_lrno ?? "",
            vehicle_reported_date: singleTrip?.vehicle_reported_date ?? "",
            vehicle_disptch_date: singleTrip?.vehicle_disptch_date ?? "",
            actual_diesel_provided: singleTrip?.actual_diesel_provided ?? "",
            actual_adblue_provided: singleTrip?.actual_adblue_provided ?? "",
            actual_driver_trip_advance: singleTrip?.actual_driver_trip_advance ?? "",
            actual_miscellaneous_expense: singleTrip?.actual_miscellaneous_expense ?? "",
            actualMiscExpenceRemarks: singleTrip?.remarks ?? "",
            destination_reported_date: singleTrip?.destination_reported_date ?? "",
            destination_unloading_date: singleTrip?.destination_unloading_date ?? "",
            POD_upload: singleTrip?.POD_upload ?? "",
            POD_remarks: singleTrip?.POD_remarks ?? "",
            actual_shortage: singleTrip?.actual_shortage ?? "",
            trip_status: singleTrip?.trip_status,
            review_status: singleTrip?.review_status,
            loadingCharges: singleTrip?.cust_loading_charges ?? "",
            unloadingCharge: singleTrip?.cust_unloading_charge ?? "",
            miscellaneousCharges: singleTrip?.cust_miscellaneous_charges ?? "",
            miscellaneousRemarks: singleTrip?.cust_miscellaneous_remarks ?? "",
            dieselRate: singleTrip?.actual_diesel_provided ?? "",
            adblueRate: singleTrip?.actual_adblue_provided ?? "",
            foodAllowance: singleTrip?.food_allowance ?? "",
            hsd: singleTrip?.hsd ?? "",
            policeExpense: singleTrip?.police_expense ?? "",
            parking: singleTrip?.parking ?? "",
            miscellaneousRate: singleTrip?.miscellaneous_rate ?? "",
         });
      }
   }, [singleTrip]);

   // Handle approve reject
   const handleApproveReject = (status) => {
      const request = {
         id: params.id,
         model_id: 2,
         action_id: 2,
         status,
         flag: "review_status",
         _method: "PATCH",
      };
      dispatch(backdropLoadingAction(true));
      dispatch(
         updateTripReviewStatusAsync({
            data: request,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Review status changed successfully.");
               navigate("/trip/contractual/view");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const handleAddMore = () => {
      if (!Object.values(modalData).every((item) => item)) {
         setAddMoreError(true);
         return;
      } else {
         setAddMoreError(false);
      }
      const payload = {
         model_id: "2",
         action_id: "3",
         trip_id: params.id,
         field_name: modal.type,
         field_value: modalData.fieldValue,
         comment: modalData.comment,
         date: modalData.date,
      };

      dispatch(backdropLoadingAction(true));
      dispatch(
         createActualAsync({
            data: payload,
            err: () => {
               dispatch(backdropLoadingAction(false));
               //toast.error("Something went wrong !");
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
               dispatch(singleTripAsync({ id: params.id }));
               toast.success("Successfully add.");
               setModal((prev) => ({ ...prev, isOpen: false }));
               setModalData({
                  date: "",
                  fieldValue: "",
                  comment: "",
               });
            },
         }),
      );
   };

   const handleUpdateApprove = () => {
      const request = {
         id: params.id,
         // vehicle_disptch_date: formData.vehicle_disptch_date,
         model_id: 2,
         action_id: 2,
         _method: "PATCH",
      };

      const newData = new FormData();
      Object.entries(request).forEach(([key, value]) => {
         newData.append(key, value);
      });

      dispatch(backdropLoadingAction(true));

      dispatch(
         approveTripDetailsAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Updated successfully.");
               setIsUpdated(true);
               navigate("/trip/contractual/view");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   useEffect(() => {
      if (values.destination_unloading_date && singleTrip?.destination_reported_date) {
         const unloadingDate = new Date(values.destination_unloading_date);
         const destinitionReportedDate = new Date(singleTrip.destination_reported_date);
         const diff = unloadingDate - destinitionReportedDate;
         setDiffMs(diff);
         setDiffDays(Math.floor(diff / (1000 * 60 * 60 * 24)));  
      }
   }, [values.destination_unloading_date, singleTrip?.destination_reported_date]);

   const handleUpdateReject = () => {
      const request = {
         id: params.id,
         // vehicle_disptch_date: formData.vehicle_disptch_date,
         model_id: 2,
         action_id: 2,
         _method: "PATCH",
      };

      const newData = new FormData();
      Object.entries(request).forEach(([key, value]) => {
         newData.append(key, value);
      });

      dispatch(backdropLoadingAction(true));

      dispatch(
         rejectTripDetailsAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Updated successfully.");
               setIsUpdated(true);
               navigate("/trip/contractual/view");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const handleUpdateTrip = () => {
      const formData = values;
      const request = {
         id: params.id,
         vehicle_disptch_date: formData.vehicle_disptch_date,
         model_id: 2,
         action_id: 3,
         _method: "PATCH",
         ...formData,
      };

      const newData = new FormData();
      Object.entries(request).forEach(([key, value]) => {
         if (key === "POD_upload" && typeof value === "string") {
            return;
         } else {
            newData.append(key, value);
         }
         
         //console.log("key", key);
      });
      //console.log("newData", request);
      //return;
      dispatch(backdropLoadingAction(true));

      dispatch(
         updateTripDetailsAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Updated successfully.");
               setIsUpdated(true);
               navigate("/trip/contractual/view");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const driverMaster = useSelector((state) => state.driverMaster);

   const vendorsData =
      driverMaster?.singleEditVehicleMaster?.map?.((item) => ({
         label: item?.vehicle_no,
         value: item?.id,
         id: item?.id,
      })) || [];

   const lanesData = [
      ...(laneForTrip?.map?.((item) => ({
         label: item?.name,
         value: item?.id,
         id: item?.id,
      })) || []),
   ];

   if (
      singleTrip?.lane_masters &&
      !lanesData.find((l) => l.value == singleTrip.lane_masters.id)
   ) {
      lanesData.push({
         label: singleTrip.lane_masters.name,
         value: singleTrip.lane_masters.id,
         id: singleTrip.lane_masters.id,
      });
   }

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         fetchAllFleetEditAsync({
            done: () => dispatch(backdropLoadingAction(false)),
            err: () => dispatch(backdropLoadingAction(false)),
         }),
      );
   }, []);
   return (
      <>
         <CustomModal
            showModal={modal.isOpen}
            title={modal.title}
            handleCloseModal={() => {
               setModal((prev) => ({ ...prev, isOpen: false }));
               setModalData({
                  date: "",
                  fieldValue: "",
                  comment: "",
               });
            }}
            onSubmit={() => {
               if (modal.type === "reject") {
                  handleApproveReject("rejected");
               } else {
                  handleAddMore();
               }
            }}
            child={
               modal.type === "reject" ? (
                  <CustomTextArea
                     name="rejectRemarks"
                     value={rejectRemarks}
                     onChange={(e) => setRejectRemarks(e.target.value)}
                  />
               ) : (
                  <div>
                     <CustomDatePicker
                        require={true}
                        label="Date"
                        onChange={(date) =>
                           setModalData({ ...modalData, date: date.target.value })
                        }
                        value={modalData?.date}
                     />
                     <CustomInput
                        require={true}
                        placeholder="E.g 100Rs"
                        label="Amount"
                        onChange={(value) =>
                           setModalData({ ...modalData, fieldValue: value.target.value })
                        }
                        value={modalData?.fieldValue}
                     />
                     <CustomInput
                        require={true}
                        placeholder="Enter the reason"
                        label="Reason"
                        onChange={(value) =>
                           setModalData({ ...modalData, comment: value.target.value })
                        }
                        value={modalData?.comment}
                     />
                     {addMoreError && (
                        <p className="text-danger">All fields are required!</p>
                     )}
                  </div>
               )
            }
         />
         <div>
            <BodyHeader title="Edit Trip Request" />

            <p className="text-danger pl-3 text-lg font-weight-bold">
               {values.trip_status === "closed" && "Trip has been closed"}
            </p>
            <form className="p-3 shadow-lg" onSubmit={formik.handleSubmit}>
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">General Details</h3>
                  </div>
                  <div className="card-body">
                     <div className="row">
                        {/* Vehicle No */}
                        <div className="col-lg-4">
                           <label className="text-bold">Vehicle No.</label>
                           <CustomDropdown
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              optionData={vendorsData}
                              {...getFieldProps("vehicle_no")}
                              onChange={(value) => {
                                 if (value && value.length > 0 && value[0]?.id) {
                                    // Set the value in formik
                                    formik.setFieldValue("vehicle_no", value[0]?.id);

                                    // Dispatch Redux action
                                    dispatch(
                                       fetchDriverRecordByVendorIdAsync({
                                          id: value[0]?.id,

                                          err: () => {
                                             dispatch(backdropLoadingAction(false));
                                          },
                                          done: () => {
                                             dispatch(backdropLoadingAction(false));
                                          },
                                       }),
                                    ).then((res) => {
                                       formik.setFieldValue(
                                          "drivername",
                                          res?.payload?.name ?? "",
                                       );
                                       formik.setFieldValue(
                                          "driverno",
                                          res?.payload?.mobile ?? "",
                                       );
                                    });
                                 }
                              }}
                           />
                        </div>

                        <div className="col-lg-4">
                           <label className="text-bold">Driver name</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="drivername"
                              {...getFieldProps("drivername")}
                           />
                        </div>

                        {/* Driver number */}
                        <div className="col-lg-4">
                           <label className="text-bold">Driver No.</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="driverno"
                              {...getFieldProps("driverno")}
                           />
                        </div>
                     </div>
                  </div>
               </div>

               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Lane Details</h3>
                  </div>
                  <div className="card-body">
                     <div className="row">
                        {/* lane name */}
                        <div className="col-lg-4">
                           <label className="text-bold">Lane Name</label>
                           <CustomDropdown
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              optionData={lanesData}
                              {...getFieldProps("lane")}
                              errors={touched.lane && errors.lane}
                              message={errors.lane}
                              onChange={(value) => {
                                 if (value && value.length > 0 && value[0]?.id) {
                                    formik.setFieldValue("lane", value[0]?.id);

                                    // Dispatch Redux action
                                    dispatch(
                                       fetchLaneRecordByIdAsync({
                                          id: value[0]?.id,

                                          err: () => {
                                             dispatch(backdropLoadingAction(false));
                                          },
                                          done: () => {
                                             dispatch(backdropLoadingAction(false));
                                          },
                                       }),
                                    ).then((res) => {
                                       formik.setFieldValue(
                                          "customername",
                                          res?.payload[0]?.customer_master?.name ?? "",
                                       );
                                       formik.setFieldValue(
                                          "origin",
                                          res?.payload[0]?.origin_location_master?.name ??
                                             "",
                                       );
                                       formik.setFieldValue(
                                          "destination",
                                          res?.payload[0]?.destination_location_master
                                             ?.name ?? "",
                                       );
                                    });
                                 }
                              }}
                           />
                        </div>

                        {/* lane name */}
                        {/* <div className="col-lg-4">
                           <label className="text-bold">Lane Name</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="lane"
                              {...getFieldProps("lane")}
                           />
                        </div> */}

                        <div className="col-lg-4">
                           <label className="text-bold">Customer name</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="customername"
                              {...getFieldProps("customername")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <label className="text-bold">Origin</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="origin"
                              {...getFieldProps("origin")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <label className="text-bold">Destination</label>
                           <CustomInput
                              disabled={true}
                              optionData={selectOptionData}
                              name="destination"
                              {...getFieldProps("destination")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="E waybill No."
                              id="EWayBillNo"
                              placeholder="E waybill No."
                              name="ewaybillno"
                              {...getFieldProps("ewaybillno")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="E Waybill Expiry Date & Time"
                              name="ewaybill_expiry_date"
                              id="EWayExpiry"
                              {...getFieldProps("ewaybill_expiry_date")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="Invoice No."
                              id="invoiceNo"
                              placeholder="Invoice No."
                              name="invoice_no"
                              {...getFieldProps("invoice_no")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="Invoice Date"
                              name="invoice_date"
                              id="invoiceDate"
                              {...getFieldProps("invoice_date")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="Invoice value"
                              id="invoiceValue"
                              placeholder="Invoice value"
                              value={values.invoice_value}
                              name="invoice_value"
                              {...getFieldProps("invoice_value")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="Customer / LR no."
                              id="customer_eisakuLRNo"
                              placeholder="Customer / LR no."
                              name="customer_lrno"
                              {...getFieldProps("customer_lrno")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="Vehicle reported date time"
                              name="vehicle_reported_date"
                              id="vehicleReportedDate"
                              {...getFieldProps("vehicle_reported_date")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="Vehicle disptch date time"
                              name="vehicle_disptch_date"
                              id="vehicleDispatchDate"
                              {...getFieldProps("vehicle_disptch_date")}
                           />
                        </div>

                        <div className="flex-grow-1">
                           <CustomInput
                              disabled={
                                 values.review_status !== "pending" ||
                                 roleName === "corporateAdmin" ||
                                 roleName === "driver"
                              }
                              label="Actual driver trip advance"
                              id="actualDriverTripAdvance"
                              placeholder="E.g 100Rs"
                              inputType="number"
                              name="actual_driver_trip_advance"
                              {...getFieldProps("actual_driver_trip_advance")}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              require
                              label="Loading charges"
                              id="loadingCharges"
                              placeholder="Enter amount"
                              {...getFieldProps(`loadingCharges`)}
                              errors={touched?.loadingCharges && errors?.loadingCharges}
                              message={errors?.loadingCharges}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              require
                              label="Unloading charge"
                              id="unloadingCharge"
                              placeholder="Enter amount"
                              {...getFieldProps(`unloadingCharge`)}
                              errors={touched?.unloadingCharge && errors?.unloadingCharge}
                              message={errors?.unloadingCharge}
                           />
                        </div>

                        {/* New fields comes from Lane these will be accessable by corporate admin  */}

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              require
                              label="Diesel Rupees"
                              id="dieselRate"
                              placeholder="Enter diesel rate"
                              {...getFieldProps(`dieselRate`)}
                              errors={touched?.dieselRate && errors?.dieselRate}
                              message={errors?.dieselRate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              require
                              label="Adblue Rupees"
                              id="adblueRate"
                              placeholder="Enter adblue rate"
                              {...getFieldProps(`adblueRate`)}
                              errors={touched?.adblueRate && errors?.adblueRate}
                              message={errors?.adblueRate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              label="Food Allowance"
                              id="foodAllowance"
                              placeholder="Enter amount"
                              {...getFieldProps(`foodAllowance`)}
                              errors={touched?.foodAllowance && errors?.foodAllowance}
                              message={errors?.foodAllowance}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={roleName === "manager" || roleName === "driver"}
                              inputType="number"
                              label="HSD"
                              id="hsd"
                              placeholder="Enter amount"
                              {...getFieldProps(`hsd`)}
                              errors={touched?.hsd && errors?.hsd}
                              message={errors?.hsd}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              label="Police Expense"
                              id="police_expense"
                              placeholder="Enter amount"
                              {...getFieldProps(`policeExpense`)}
                              errors={touched?.policeExpense && errors?.policeExpense}
                              message={errors?.policeExpense}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              label="Parking"
                              id="parking"
                              placeholder="Enter amount"
                              {...getFieldProps(`parking`)}
                              errors={touched?.parking && errors?.parking}
                              message={errors?.parking}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              inputType="number"
                              label="Miscellaneous Rate"
                              id="miscellaneousRate"
                              placeholder="Enter miscellaneous rate"
                              {...getFieldProps(`miscellaneousRate`)}
                              errors={
                                 touched?.miscellaneousRate && errors?.miscellaneousRate
                              }
                              message={errors?.miscellaneousRate}
                           />
                        </div>

                        <div className="col-lg-4  mt-4">
                           {values.destination_unloading_date && (
                              <div className="font-weight-bold text-dark pt-3">
                                 Detention Charge:&nbsp;
                                 <span className="text-primary">
                                    {new Intl.NumberFormat("en-IN", {
                                       style: "currency",
                                       currency: "INR",
                                       minimumFractionDigits: 2,
                                    }).format(
                                       (singleTrip?.cust_detention_rate ?? 0.0) *
                                          Math.max(
                                             (diffDays -
                                                Number(singleTrip?.cust_detention_delay ?? 0)),
                                             0,
                                          ),
                                    )}
                                 </span>
                              </div>
                           )}
                        </div>

                        <div className="col-lg-12">
                           <CustomTextArea
                              label="Miscellaneous Expense Remarks"
                              id="actualMiscExpenceRemarks"
                              name="actualMiscExpenceRemarks"
                              placeholder="Remarks"
                              {...getFieldProps("actualMiscExpenceRemarks")}
                              errors={
                                 touched?.actualMiscExpenceRemarks &&
                                 errors?.actualMiscExpenceRemarks
                              }
                              message={errors?.actualMiscExpenceRemarks}
                           />
                        </div>
                        {/* Manager edit fields */}

                        {values.review_status !== "pending" && (
                           <>
                              {roleName !== "management" && (
                                 <>
                                    <div className="col-lg-4">
                                       <CustomDateTimePicker
                                          disabled={values.trip_status === "closed"}
                                          label="Destination Reported date time"
                                          name="destination_reported_date"
                                          min={new Date().toISOString().slice(0, 16)}
                                          id="destinationReportedTime"
                                          {...getFieldProps("destination_reported_date")}
                                          errors={
                                             touched?.destination_reported_date &&
                                             errors?.destination_reported_date
                                          }
                                          message={errors?.destination_reported_date}
                                       />
                                    </div>

                                    <div className="col-lg-4">
                                       <CustomDateTimePicker
                                          disabled={values.trip_status === "closed"}
                                          label="Destination Unloading date time"
                                          name="destination_unloading_date"
                                          min={new Date().toISOString().slice(0, 16)}
                                          id="destinationUnloadingTime"
                                          {...getFieldProps("destination_unloading_date")}
                                          errors={
                                             touched?.destination_unloading_date &&
                                             errors?.destination_unloading_date
                                          }
                                          message={errors?.destination_unloading_date}
                                       />
                                    </div>

                                    <div className="col-lg-4">
                                       <CustomFileUpload
                                          disabled={values.trip_status === "closed"}
                                          label="POD"
                                          id="pod"
                                          accept=".jpg, .pdf, .jpeg, .png"
                                          {...getFieldProps("POD_upload")}
                                          onChange={(e) => {
                                             setFieldValue(
                                                "POD_upload",
                                                e.target.files[0],
                                             );
                                          }}
                                          errors={
                                             touched?.POD_upload && errors?.POD_upload
                                          }
                                          message={errors?.POD_upload}
                                       />
                                    </div>
                                 </>
                              )}

                              {["manager", "corporateAdmin", "management"].includes(roleName) && (
                                 <div className="col-lg-8">
                                    <div className="row">
                                       <div className="col-6">
                                          <CustomInput
                                             inputType="number"
                                             label="Actual Shortage"
                                             
                                             {...getFieldProps(`actual_shortage`)}
                                             errors={
                                                touched?.actual_shortage &&
                                                errors?.actual_shortage
                                             }
                                             message={errors?.actual_shortage}
                                          />
                                       </div>

                                       {values.actual_shortage && (
                                          <div className="col-6 d-flex align-items-center pt-3">
                                             Shortage Deficit:&nbsp;
                                             <strong>
                                                {Math.max(
                                                   (values?.actual_shortage ?? 0) -
                                                      (singleTrip?.lane_masters
                                                         ?.shortage ?? 0),
                                                   0,
                                                )}{" "}
                                                Litre
                                             </strong>
                                          </div>
                                       )}
                                    </div>
                                 </div>
                              )}

                              <div className="col-lg-12">
                                 <CustomTextArea
                                    disabled={values.trip_status === "closed"}
                                    label="POD(Remarks)"
                                    id="podRemarks"
                                    name="POD_remarks"
                                    placeholder="Remarks"
                                    {...getFieldProps("POD_remarks")}
                                    errors={touched?.POD_remarks && errors?.POD_remarks}
                                    message={errors?.POD_remarks}
                                 />
                              </div>
                           </>
                        )}
                        <div className="col-lg-12 d-flex justify-content-center">
                           <button
                              className="btn btn-primary px-4 py-3 mr-3"
                              type="button"
                              onClick={handleUpdateTrip}
                           >
                              <h6 className="mb-0 text-uppercase">Update</h6>
                           </button>

                           {roleName === "management" &&
                              values.review_status === "pending" && (
                                 <>
                                    <button
                                       className="btn btn-success px-4 py-3 me-2"
                                       type="button"
                                       onClick={handleUpdateApprove}
                                    >
                                       <h6 className="mb-0 text-uppercase">Approve</h6>
                                    </button>

                                    <button
                                       className="btn btn-danger px-4 py-3 ml-3"
                                       type="button"
                                       onClick={handleUpdateReject}
                                    >
                                       <h6 className="mb-0 text-uppercase">Reject</h6>
                                    </button>
                                 </>
                              )}
                        </div>
                     </div>
                  </div>
               </div>
               {/* APPROVE REJECT */}
               {/* {roleName === "manager" && (
                  <div className="col-12 mt-4 text-center">
                     {values.review_status !== "approved" && (
                        <button
                           className="btn btn-success px-4 py-3"
                           type="button"
                           onClick={() => handleApproveReject("approved")}
                        >
                           <h6 className="mb-0 text-uppercase">Approve</h6>
                        </button>
                     )}

                     {!(
                        values.review_status === "rejected" ||
                        values.review_status === "approved"
                     ) && (
                        <button
                           className="btn btn-danger ml-3 px-4 py-3"
                           type="button"
                           onClick={() => setModal({ isOpen: true, type: "reject" })}
                        >
                           <h6 className="mb-0 text-uppercase">Reject</h6>
                        </button>
                     )}
                  </div>
               )} */}
            </form>
         </div>
      </>
   );
}
